import React, { useState } from 'react';
import { Dialog, Selector } from '@leverege/ui-elements';
import { LoadingView } from '@leverege/molten/views';
import { Attributes } from '@leverege/ui-attributes';
import { useSelector } from 'react-redux';
import { Config } from '@leverege/plugin';
import { Project } from '@leverege/api-redux';
import RecovrSales from '../../util/RecovrSales';
import S from './ReconcileSalesDialog.css';
import { jsx as _jsx } from "react/jsx-runtime";
function ReconcileSalesDialog(props) {
  const {
    show,
    onClose,
    sales,
    reloadData
  } = props;
  const [reconcileState, setReconcileState] = useState('notReconciled');
  // get enum name from api ui
  const reconcileSalesEnumName = Config.get('ReconcileSalesEnum', 'usageTypeEnum', 'reconcileSalesType');
  // get values of enum from state
  const reconcileSaleEnums = useSelector(state => Project(window.Molten.getConfig('api/projectId')).enum(reconcileSalesEnumName).getEnum(state));
  // create an array of objects containing the name and value of the enums
  const enumsArray = reconcileSaleEnums?.values?.map(val => ({
    name: val.name,
    value: val.value
  })) || [];
  const onOkay = async () => {
    const closeLoading = LoadingView.showDialog('Reconciling Sale');
    try {
      const companyId = Attributes.get('sale.company', 'sale', sales[0].data);
      const locationId = Attributes.get('sale.sales', 'sale', sales[0].data);
      await RecovrSales.reconcileSales({
        companyId,
        locationId,
        sales,
        reconcileState,
        reloadData
      });
      await reloadData();
    } catch (err) {
      console.error('Could not reconcile sales: ', err);
    }
    closeLoading();
    onClose();
  };
  const onCancel = () => {
    const {
      onClose
    } = props;
    onClose();
  };
  const okayTitle = sales.length > 1 ? `Update Sales (${sales.length})` : 'Update Sale';
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    onClose: onClose,
    icon: "",
    title: sales.length > 1 ? 'Reconcile Sales' : 'Reconcile Sale',
    okay: okayTitle,
    okayVariant: "primary",
    cancelVariant: "secondary",
    onOkay: onOkay,
    onCancel: onCancel,
    children: /*#__PURE__*/_jsx(Selector, {
      className: S.selector,
      id: "reconcileState",
      value: reconcileState,
      values: enumsArray,
      onChange: event => {
        setReconcileState(event.value);
      }
    })
  });
}
export default ReconcileSalesDialog;